import React, { useState } from 'react';
import './ThoughtsDisplay.css';

interface ThoughtsDisplayProps {
  thoughts: string[];
  className?: string;
}

const ThoughtsDisplay: React.FC<ThoughtsDisplayProps> = ({ thoughts, className = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!thoughts || thoughts.length === 0) {
    return null;
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`thoughts-display ${className}`}>
      <button 
        className="thoughts-header"
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
        aria-label={isExpanded ? 'Collapse thoughts' : 'Expand thoughts'}
      >
        <div className="thoughts-header-content">
          <span className="thoughts-icon">💭</span>
          <span className="thoughts-title">Thoughts</span>
          <span className="thoughts-count">({thoughts.length})</span>
        </div>
        <div className={`thoughts-chevron ${isExpanded ? 'expanded' : ''}`}>
          ▼
        </div>
      </button>
      
      {isExpanded && (
        <div className="thoughts-content">
          <ul className="thoughts-list">
            {thoughts.map((thought, index) => (
              <li key={index} className="thought-item">
                <span className="thought-bullet">•</span>
                <span className="thought-text">{thought}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ThoughtsDisplay;
